module.exports = __webpack_public_path__ + "static/media/nelogica.1ac051af.svg";